import * as React from 'react';

// type for void function with any arguments
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type VoidFunction = (...args: any[]) => void;

function mergeProps<T extends object>(propsMaster: T, props: T): T {
  // Make a copy of the master props object
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mergedProps: any = {};

  // Loop through the keys of the propsMaster object
  for (const key in propsMaster) {
    // If the key does not exist in the props object
    if (!(key in props)) {
      mergedProps[key] = propsMaster[key];
      continue;
    }

    const isMasterFunction = typeof propsMaster[key] === 'function';
    const isPropFunction = typeof props[key] === 'function';

    // If the value of the key is a function
    if (isMasterFunction && isPropFunction) {
      // Merge the functions
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mergedProps[key] = (...args: any[]) => {
        (propsMaster[key] as VoidFunction)(...args);
        (props[key] as VoidFunction)(...args);
      };
      continue;
    }
  }

  // Loop through the keys of the props object
  for (const key in props) {
    // If the key does not exist in the merged props object
    if (!(key in mergedProps)) {
      // Add the key to the merged props object
      mergedProps[key] = props[key];
    }
  }

  return mergedProps as T;
}

function useFieldInputMergeProps<T extends object>(props: T) {
  return React.useMemo(() => (propsMaster: T) => mergeProps<T>(propsMaster, props), [props]);
}

export { useFieldInputMergeProps, mergeProps };
